export const base64Encode = (input: string): string => {
  return btoa(encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, (_, p1) => String.fromCharCode(parseInt(p1, 16))));
};

export const base64Decode = (input: string): string => {
  const binString = atob(input.replace(/ /g, "+").replace(/-/g, "+").replace(/_/g, "/"));
  const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0) as number);
  const decoder = new TextDecoder();
  return decoder.decode(bytes);
};
